import { ConfirmationModal } from './ConfirmationModal';

interface UnsavedChangesConfirmationModalProps {
  isOpen: boolean;
  onClose: (reason: 'confirm' | 'cancel') => void;
}

/**
 * Canonical "Unsaved changes" confirmation. `confirm` = Stay (cancel
 * navigation), `cancel` = Leave (proceed with navigation).
 */
export function UnsavedChangesConfirmationModal({
  isOpen,
  onClose,
}: UnsavedChangesConfirmationModalProps) {
  return (
    <ConfirmationModal
      isOpen={isOpen}
      closeOnOutsideClick={false}
      onClose={onClose}
      heading="Unsaved changes"
      cancelText="Leave"
      confirmText="Stay"
      cancelButtonProps={{
        variant: 'destructive-primary',
      }}
      confirmButtonProps={{
        variant: 'secondary',
      }}
    >
      Are you sure you want to leave? Changes that you&apos;ve made will not be
      saved.
    </ConfirmationModal>
  );
}
